<template>
  <Layout>
    <template v-if="$route.query.ext !== undefined">
      <External />

      <RouterLink :to="{ name: 'login' }" class="mt-3 d-block">
        <i class="bi bi-arrow-left"></i>
        Назад к выбору типа учётной записи
      </RouterLink>
    </template>
    <template v-else>
      <div class="vstack gap-3 auth-type">
        <div class="lead text-center">Выберите тип учетной записи</div>
        <a
          :href="sso.auth_uri"
          v-if="sso"
        >
          Сотрудник (внутренний тип учетной записи)
        </a>
        <RouterLink :to="{ name: 'login', query: { ext: 1 } }">
          Внешний пользователь (внешний тип учетной записи)
        </RouterLink>
      </div>
    </template>
  </Layout>
</template>

<script setup>
import { onMounted } from 'vue'
import { useApi } from '@provise/composables/api'
import { useCookies } from '@vueuse/integrations/useCookies'
import config from '@/config'
import Layout from './login/layout.vue'
import External from './login/external.vue'

const { model: sso, refresh: getSso } = useApi({
  url: '/web/login',
})
const { set: setCookue } = useCookies(['service'])

onMounted(async () => {
  setCookue('service', config.VITE_SERVICE_SELF, {
    domain: config.VITE_PRIMARY_DOMAIN,
    path: '/',
    sameSite: 'lax',
  })
  await getSso()
})
</script>
